var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5797_2706)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 5,
    height: 16,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31085 18.7084C7.19007 18.7106 7.07006 18.6885 6.95799 18.6434C6.84592 18.5983 6.74408 18.5311 6.65854 18.4458C6.573 18.3605 6.50551 18.2588 6.4601 18.1469C6.41468 18.0349 6.39226 17.915 6.39419 17.7942V2.17502C6.39204 2.05409 6.41428 1.93397 6.4596 1.82183C6.50492 1.70969 6.57237 1.60783 6.65794 1.52235C6.7435 1.43686 6.84542 1.3695 6.9576 1.32429C7.06978 1.27907 7.18992 1.25693 7.31085 1.25919C7.83085 1.25919 8.22752 1.65586 8.22752 2.17502V17.7934C8.22955 17.9142 8.20722 18.0343 8.16185 18.1463C8.11649 18.2583 8.04901 18.3601 7.96346 18.4455C7.87791 18.5309 7.77603 18.5982 7.66391 18.6433C7.55178 18.6885 7.43171 18.7106 7.31085 18.7084Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5999 19.1668H3.43075C3.08988 19.1675 2.75222 19.1009 2.43711 18.9709C2.122 18.8409 1.83561 18.6501 1.59434 18.4093C1.35308 18.1685 1.16167 17.8825 1.03107 17.5676C0.900474 17.2527 0.833251 16.9152 0.833252 16.5743V3.42517C0.833361 3.08436 0.900664 2.74693 1.03131 2.43216C1.16196 2.11739 1.35338 1.83148 1.59464 1.59076C1.83589 1.35005 2.12224 1.15927 2.4373 1.02933C2.75236 0.899388 3.08995 0.832844 3.43075 0.833501H16.5999C18.0057 0.833501 19.1666 1.99267 19.1666 3.426V16.5735C19.1666 18.0085 18.0057 19.1668 16.5999 19.1668ZM3.43075 2.6635C3.33023 2.66239 3.2305 2.68134 3.13739 2.71924C3.04429 2.75715 2.95968 2.81324 2.88852 2.88425C2.81736 2.95526 2.76108 3.03974 2.72297 3.13276C2.68486 3.22579 2.66569 3.32548 2.66659 3.426V16.5735C2.66659 17.001 3.00242 17.3368 3.43075 17.3368H16.5999C16.7004 17.3379 16.8002 17.319 16.8933 17.2811C16.9864 17.2432 17.071 17.1871 17.1421 17.1161C17.2133 17.0451 17.2696 16.9606 17.3077 16.8676C17.3458 16.7745 17.365 16.6749 17.3641 16.5743V3.42517C17.3333 2.9985 16.9974 2.66267 16.5999 2.66267L3.43075 2.6635Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5797_2706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpen);
export default __webpack_public_path__ + "static/media/sidebarOpen.de6b0d5de907a261d53a0ca937a6a2f5.svg";
export { ForwardRef as ReactComponent };